const data = {
  Page: {
    id: 1,
    PageBasicInfo: {
      pageName: {
        "@max": 64,
      },
      BackgroundColor: {
        RGB: 0,
      },
      playDurationMode: {
        "@opt": "selfDefine,auto",
        // "@opt": "selfDefine,auto,loop",
      },
      playDuration: {
        "@min": 10,
        "@max": 604800,
        "@default": 10,
        // "@default": 60,
      },
      playCount: {
        "@min": 1,
        "@max": 999999,
      },
      switchDuration: {
        "@min": 1,
        "@max": 60,
      },
      switchEffect: {
        "@opt": "none,gradient",
      },
      animationBlockType: {
        "@opt": "ball,leaf,snow,pater,null",
      },
      backgroundPic: 1,
      SignInCfg: {
        VoiceBroadcast: {
          enabled: {
            "@opt": "true,false",
          },
          broadcastSpeed: {
            "@opt": "slower,slow,medium,fast,faster",
          },
          inLibVoice: {
            "@min": 0,
            "@max": 128,
          },
          outLibVoice: {
            "@min": 0,
            "@max": 128,
          },
          abnormalTemperatureVoice: {
            "@min": 0,
            "@max": 128,
          },
        },
        WelcomeWord: {
          enabled: {
            "@opt": "true,false",
          },
          inLibWord: {
            "@min": 0,
            "@max": 128,
          },
          outLibWord: {
            "@min": 0,
            "@max": 128,
          },
        },
        SignCartoon: {
          signCartoonSpeed: {
            "@opt": "fast,medium,slow",
          },
        },
        backgroundSignEnabled: {
          "@opt": "true,false",
        },
        TemperatureDetection: {
          enabled: {
            "@opt": "true,false",
          },
          threshold: {
            "@min": 0,
            "@max": 100,
          },
        },
      },
    },
    WindowsList: [
      {
        "@size": 128,
      },
      {
        Windows: {
          id: 1,
          Position: {
            positionX: {
              "@min": 0,
              "@max": 1919,
            },
            positionY: {
              "@min": 0,
              "@max": 1919,
            },
            height: {
              "@min": 1,
              "@max": 1920,
            },
            width: {
              "@min": 1,
              "@max": 1920,
            },
          },
          layerNo: {
            "@min": 1,
            "@max": 128,
          },
          WinMaterialInfo: {
            materialType: {
              "@opt": "static,dynamic,other",
            },
            staticMaterialType: {
              "@opt": "picture,audio,video,document,pdf,ppt,doc,excel,web,app,zip",
              // "@opt": "picture,audio,video,document,pdf,web,app,zip",
            },
            dynamicType: {
              "@opt":
                "web,call,dynamicPic,realStream,capturePic,character,chart",
            },
            otherType: {
              "@opt": "clock,weather,countdown,localInput,hyperlinkBtn",
            },
          },
          TouchProperty: {
            windType: {
              "@opt": "popup,page",
            },
            hyperlinkType: {
              "@opt": "window,page",
            },
            windowId: 1,
            pageId: 1,
          },
          PlayItemList: [
            {
              "@size": 256,
            },
            {
              PlayItem: {
                id: 1,
                materialNo: 1,
                inputChannel: {
                  "@min": 1,
                  "@max": 16,
                },
                playEffect: {
                  "@opt": "none,marquee",
                },
                MarqueeInfo: {
                  scrollType: {
                    "@opt": "none,loops,once,backAndForth",
                  },
                  scrollDeriction: {
                    "@opt": "none,up,down,left,right",
                  },
                  scrollSpeed: {
                    "@min": 1,
                    "@max": 9,
                  },
                },
                PlayDuration: {
                  durationType: {
                    "@opt": "materialTime,selfDefine",
                  },
                  duration: {
                    "@min": 10,
                    "@max": 604800,
                    default: 10,
                  },
                },
                CharactersEffect: {
                  fontSize: {
                    "@min": 20,
                    "@max": 400,
                  },
                  FontColor: {
                    RGB: 0,
                  },
                  BackColor: {
                    RGB: 0,
                  },
                  backTransparent: {
                    "@min": 0,
                    "@max": 255,
                  },
                  subtitlesEnabled: "false",
                  scrollDirection: {
                    "@opt": "left,right,up",
                  },
                  scrollSpeed: {
                    "@min": 1,
                    "@max": 9,
                  },
                  strikethroughEnabled: "true",
                  fontBorderEnabled: "true",
                  fontShadowEnabled: "true",
                  fontGradientEnabled: "true",
                },
                switchEffect: {
                  "@opt":
                    "none,random,rightInLeftOut,leftInRightOut,bottomInTopOut,topInBottomOut,fadeInFadeOut,middleExit,topPop,rightBottomIn,leftTopIn",
                },
                animationEffect: {
                  repetTime: 1,
                  durationTime: 1500,
                  delayTime: 1000,
                },
                pageTime: {
                  "@min": 10,
                  "@max": 60,
                },
                scrollSpeed: {
                  "@min": 1,
                  "@max": 9,
                },
              },
            },
          ],
          enabledAudio: {
            "@opt": "true,false",
          },
          enableHide: {
            "@opt": "true,false",
          },
          enableLock: {
            "@opt": "true,false",
          },
          filletedCornerDegree: {
            "@min": 0,
            "@max": 45,
          },
          rotateDegree: {
            "@min": 0,
            "@max": 360,
          },
          AppWindow: {
            WindowInfoList: [
              {
                "@size": 1,
              },
              {
                WindowInfo: {
                  id: 0,
                  materialNo: 0,
                },
              },
            ],
          },
          Call: {
            materialNo: 0,
            tableRow: {
              "@min": 1,
              "@max": 20,
            },
            tableColumn: {
              "@min": 1,
              "@max": 20,
            },
            tableDirection: {
              "@opt": "vertical,horizontal",
            },
            tableType: {
              "@opt":
                "template1,template2,template3,template4,template5,template6",
            },
            backPicId: 0,
            alignType: {
              "@opt": "left,right,middle",
            },
            refreshDirection: {
              "@opt": "upTodown,downToup,leftToright,rightToleft",
            },
            playType: {
              "@opt": "roll,flipOver",
            },
            HeadDataList: [
              {
                "@size": 20,
              },
              {
                HeadData: {
                  id: 0,
                  data: {
                    "@min": 1,
                    "@max": 100,
                  },
                },
              },
            ],
            ItemStyleList: [
              {
                "@size": 20,
              },
              {
                ItemStyle: {
                  id: 0,
                  width: {
                    "@min": 1,
                    "@max": 100,
                  },
                  fontSize: {
                    "@min": 30,
                    "@max": 400,
                  },
                  FontColor: {
                    RGB: 0,
                  },
                  BackColor: {
                    RGB: 0,
                  },
                },
              },
            ],
          },
          DynamicPic: {
            materialNo: 0,
            backPicId: 0,
          },
          CapturePic: {
            backPicId: 0,
            ipcMaterialNo: 0,
            cancelType: {
              "@opt": "auto,manual",
            },
            duration: {
              "@min": 10,
              "@max": 604800,
              default: 60,
            },
          },
          ClockParam: {
            backPicId: 0,
            ClockIcon: {
              enabled: true,
              type: {
                "@opt": "clock1,clock2,clock3,clock4,clock5,clock6",
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            YmdParam: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              RGB: 0,
              positionX: {
                "@min": 0,
                "@max": 1919,
              },
              positionY: {
                "@min": 0,
                "@max": 1919,
              },
              height: {
                "@min": 1,
                "@max": 1920,
              },
              width: {
                "@min": 1,
                "@max": 1920,
              },
            },
            HmsParam: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              RGB: 0,
              positionX: {
                "@min": 0,
                "@max": 1919,
              },
              positionY: {
                "@min": 0,
                "@max": 1919,
              },
              height: {
                "@min": 1,
                "@max": 1920,
              },
              width: {
                "@min": 1,
                "@max": 1920,
              },
            },
            WeekParam: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              RGB: 0,
              positionX: {
                "@min": 0,
                "@max": 1919,
              },
              positionY: {
                "@min": 0,
                "@max": 1919,
              },
              height: {
                "@min": 1,
                "@max": 1920,
              },
              width: {
                "@min": 1,
                "@max": 1920,
              },
            },
          },
          WeatherParam: {
            backPicId: 0,
            WeatherIcon: {
              enabled: true,
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            Date: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            Temperature: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            WeatherContent: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            City: {
              enabled: true,
              cityId: {
                "@min": 1,
                "@max": 9000000,
              },
              cityName: {
                "@min": 1,
                "@max": 32,
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            Humidity: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            AirQuality: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            UpdateTime: {
              enabled: true,
              refreshTime: "",
              updateInterval: {
                "@min": 10,
                "@max": 1440,
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
            Wind: {
              enabled: true,
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
          },
          Countdown: {
            endTime: "20160128T000000+8",
            template: {
              "@opt":
                "template1,template2,template3,template4,template5,template6",
            },
            timeUnit: {
              "@opt": "year,month,week,day,hour,minute,second",
            },
            backPicId: 1,
            TimeFontCfg: {
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
            },
          },
          ChartData: {
            chartType: {
              "@opt": "hitogram,pieChart",
            },
            backPicId: 0,
            HeadDataList: [
              {
                "@size": 20,
              },
              {
                HeadData: {
                  id: 0,
                  data: {
                    "@min": 1,
                    "@max": 100,
                  },
                  headType: {
                    "@opt": "axis, value",
                  },
                },
              },
            ],
          },
          localInputNo: {
            "@opt": "VGA,HDMI",
          },
          HyperlinkBtn: {
            backPicId: 0,
          },
          CharactersAttribute: {
            fontSize: {
              "@min": 20,
              "@max": 400,
            },
            FontColor: {
              RGB: 0,
            },
            BackColor: {
              RGB: 0,
            },
            backTransparent: {
              "@min": 0,
              "@max": 255,
            },
            alignType: {
              "@opt": "left,right,middle",
            },
            verticaAlignType: {
              "@opt": "top,bottom,verticalCenter",
            },
            characterContent: {
              "@min": 0,
              "@max": 512,
            },
            characterStyle: {
              "@opt": "normal,bold",
            },
          },
          SignIn: {
            backPicId: 0,
            ShowInfo: {
              row: {
                "@min": 1,
                "@max": 10,
              },
              column: {
                "@min": 1,
                "@max": 10,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
              inLib: {
                nameEnabled: {
                  "@opt": "true,false",
                },
                genderEnabled: {
                  "@opt": "true,false",
                },
                selfDefine1Enabled: {
                  "@opt": "true,false",
                },
                selfDefine2Enabled: {
                  "@opt": "true,false",
                },
                signInTimeEnabled: {
                  "@opt": "true,false",
                },
                temperatureEnabled: {
                  "@opt": "true,false",
                },
              },
              outLib: {
                nameEnabled: {
                  "@opt": "true,false",
                },
                name: {
                  "@min": 0,
                  "@max": 128,
                },
                genderEnabled: {
                  "@opt": "true,false",
                },
                signInTimeEnabled: {
                  "@opt": "true,false",
                },
                temperatureEnabled: {
                  "@opt": "true,false",
                },
              },
              showDuration: {
                "@opt": "always,10s,20s,30s,no",
              },
            },
            MainTitle: {
              enabled: {
                "@opt": "true,false",
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              text: {
                "@min": 0,
                "@max": 32,
              },
            },
            SubTitle: {
              enabled: {
                "@opt": "true,false",
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              text: {
                "@min": 0,
                "@max": 32,
              },
            },
            NormalTemperature: {
              PeopleNumber: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              Icon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
            },
            AbnormalTemperature: {
              PeopleNumber: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              Icon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
            },
          },
          EventParam: {
            backPicId: 0,
            Title: {
              enabled: {
                "@opt": "true,false",
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
              text: {
                "@min": 0,
                "@max": 32,
              },
            },
            PeopleCounting: {
              maxPeopleNumber: {
                "@min": 0,
                "@max": 999999,
              },
              unavailableBackPicId: 0,
              supportChangeByPeople: {
                "@opt": "prompt,peopleIcon,availablePeopleNumber",
              },
              Prompt: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
                FontColor: {
                  RGB: 0,
                },
                unavailableText: {
                  "@min": 0,
                  "@max": 32,
                },
                UnavailableFontColor: {
                  RGB: 0,
                },
              },
              PeopleIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
              InsidePeopleTitle: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              InsidePeopleNumber: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
              },
              AvailablePeopleTitle: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              AvailablePeopleNumber: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                FontColor: {
                  RGB: 0,
                },
                UnavailableFontColor: {
                  RGB: 0,
                },
              },
              UnavailablePeopleIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
              AudioAlarm: {
                enabled: {
                  "@opt": "true,false",
                },
                materialNo: 0,
              },
            },
            Mask: {
              enabled: {
                "@opt": "true,false",
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
              text: {
                "@min": 0,
                "@max": 32,
              },
              MaskIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
              AudioAlarm: {
                enabled: {
                  "@opt": "true,false",
                },
                materialNo: 0,
              },
            },
            Temperature: {
              Prompt: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                BackColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              TemperatureIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
              AudioAlarm: {
                enabled: {
                  "@opt": "true,false",
                },
                materialNo: 0,
              },
              abnormalHighTemperature: {
                "@min": 0,
                "@max": 100,
              },
            },
            WearMask: {
              enabled: {
                "@opt": "true,false",
              },
              fontSize: {
                "@min": 30,
                "@max": 400,
              },
              FontColor: {
                RGB: 0,
              },
              BackColor: {
                RGB: 0,
              },
              Position: {
                positionX: {
                  "@min": 0,
                  "@max": 1919,
                },
                positionY: {
                  "@min": 0,
                  "@max": 1919,
                },
                height: {
                  "@min": 1,
                  "@max": 1920,
                },
                width: {
                  "@min": 1,
                  "@max": 1920,
                },
              },
              text: {
                "@min": 0,
                "@max": 32,
              },
              MaskIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
            },
            NormalTemperature: {
              Prompt: {
                enabled: {
                  "@opt": "true,false",
                },
                fontSize: {
                  "@min": 30,
                  "@max": 400,
                },
                FontColor: {
                  RGB: 0,
                },
                BackColor: {
                  RGB: 0,
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                text: {
                  "@min": 0,
                  "@max": 32,
                },
              },
              TemperatureIcon: {
                enabled: {
                  "@opt": "true,false",
                },
                Position: {
                  positionX: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  positionY: {
                    "@min": 0,
                    "@max": 1919,
                  },
                  height: {
                    "@min": 1,
                    "@max": 1920,
                  },
                  width: {
                    "@min": 1,
                    "@max": 1920,
                  },
                },
                materialNo: 0,
              },
            },
            NormalStatusAudioAlarm: {
              enabled: {
                "@opt": "true,false",
              },
              materialNo: 0,
            },
          },
        },
      },
    ],
    TemplateLayoutWindowList: [
      {
        "@size": 128,
      },
      {
        TemplateLayoutWindow: {
          id: 1,
          Position: {
            positionX: {
              "@min": 0,
              "@max": 1919,
            },
            positionY: {
              "@min": 0,
              "@max": 1919,
            },
            height: {
              "@min": 120,
              "@max": 1920,
            },
            width: {
              "@min": 120,
              "@max": 1920,
            },
          },
        },
      },
    ],
  },
};
export default data;
